import { Box, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useOnlineStatus from '@hooks/useOnlineStatus';
import { useIsAdmin } from '@stores/userStore';
import { AdminOfflineGuard } from './AdminOfflineGuard';
import type { ReactNode } from 'react';

type AdminAccessGuardProps = {
  children: ReactNode;
  requireAdmin?: boolean;
};

export const AdminAccessGuard = ({
  children,
  requireAdmin = true
}: AdminAccessGuardProps) => {
  const { t } = useTranslation();
  const isOnline = useOnlineStatus();
  const isAdmin = useIsAdmin();

  if (requireAdmin && !isAdmin) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          padding: 3
        }}
      >
        <Card sx={{ maxWidth: 400, textAlign: 'center' }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" gutterBottom>
              {t('settings:administration.accessDenied.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('settings:administration.accessDenied.message')}
            </Typography>
          </CardContent>
        </Card>
      </Box>
    );
  }

  if (!isOnline) {
    return <AdminOfflineGuard children={null} />;
  }

  return <>{children}</>;
};
